export default __webpack_public_path__ + "static/media/pyramid-dark.734a49fb.svg";